import { IconButton, IconButtonSize, IconButtonTheme } from '@apply/components';
import { faPlus } from '@fortawesome/free-solid-svg-icons';

interface AddBorrowerEntityButtonProps {
    onClick: () => void;
    disabled: boolean;
}

/** Opens the entity modal to add a new borrower entity (see BorrowerEntity's openEntityModal). */
export const AddBorrowerEntityButton = ({ onClick, disabled }: AddBorrowerEntityButtonProps) => {
    return (
        <IconButton
            id='borrowerEntityAdd'
            theme={IconButtonTheme.DarkBlueActive}
            size={IconButtonSize.ExtraSmall}
            icon={faPlus}
            hint='Add a new entity'
            disabled={disabled}
            handleClick={onClick}
        />
    );
};
